import { render, staticRenderFns } from "./mstrbudget-my.vue?vue&type=template&id=4c0f163c"
import script from "./mstrbudget-my.vue?vue&type=script&lang=js"
export * from "./mstrbudget-my.vue?vue&type=script&lang=js"
import style0 from "./mstrbudget-my.vue?vue&type=style&index=0&id=4c0f163c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports